import { add } from '@hotwired/stimulus';
import { data } from 'jquery';
// import * as jsv2 from 'jsv2'
// import * as jsv2 from 'jsv2/dist/jsv2.esm.js';
import * as jsv2 from 'jsv2';
console.log("jsv2 loaded", jsv2);


const GRAPH_ID = "graph-1"; // ID of the graph container
const DATA_TYPES = {
    "nmrML_1D": {
        name: "1D-NMR",
        expectedDataTag: "spectrumDataArray",
    },
    "nmrML_2D": {
        name: "2D-NMR",
        expectedDataTag: "spectrumDataArray",  // currently not used as the parser uses regex to extract x, y, z from the binary data
    },
    "lc_ms_1D": {
        name: "1D-LCMS",
        expectedDataTag: "binary",
    },
    "ei_ms_1D": {
        name: "1D-EIMS",
        expectedDataTag: "binary",
    },
    "ir_1D": {
        name: "1D-IR",
        expectedDataTag: "ms-ir-spectrum",
    },
    "uv_1D": {
        name: "1D-UV",
        expectedDataTag: null,
    },
}

document.addEventListener("DOMContentLoaded", function() {
    console.log("handle_submit.js loaded");
    
    // Get the selected file type from the dropdown
    let fileTypeDropdown = document.getElementById("input-file-type");
    let fileType = fileTypeDropdown.value;
    let fileInputElement = document.getElementById("file-selector");

    // Other configs
    let mirrorToggle = document.getElementById("mirror-toggle").checked;

    // Firsts initialization of the DataParser with the initial file type
    // Note: The file selector should be an input element with type="file" and id="file-selector"
    setupDataParser(fileInputElement, fileType);
    console.log("Initial event listener added for file selector with file type:", fileType);

    // Add an event listener to the file selector to handle file type changes from dropdown and re-initialize the DataParser
    fileTypeDropdown.addEventListener("change", function(event) {
        fileInputElement.disabled = true;

        fileType = event.target.value;
        console.log("File type changed to:", fileType);

        setupDataParser(fileInputElement, fileType);
        console.log("DataParser re-initialized for file type:", fileType);
        
        fileInputElement.disabled = false;
    });

});



function setupDataParser(fileInputElement, fileType) {

    let dataParser = new jsv2.DataParser(`#${fileInputElement.id}`, {
        dataType: DATA_TYPES[fileType].name,
        expectedDataTag: DATA_TYPES[fileType].expectedDataTag,
        // expectedAssignmentDataTag: "atomAssignmentList"
    })

    dataParser.addEventListener("fileParsed", (event) => {
        console.log("File parsed event emitted", event);
        if (fileType === "nmrML_1D") {
            plotNmrml1D(event);
        } else if (fileType == "ei_ms_1D") {
            plotEims1D(event)
        } else if (fileType === "nmrML_2D") {
            plotNmrml2D(event);
        } else if (fileType === "lc_ms_1D") {
            plotLcms1D(event);
        } else if (fileType === "ir_1D") {
            plotIr1D(event);
        } else if (fileType === "uv_1D") {
            plotUv1D(event);
        } else {
            console.error("Data parsing failed.");
        }
    })

    console.log("DataParser initialized with file type:", dataParser.data_type, 
                "and expected data tag:", dataParser.expected_data_tag);
}

function plotUv1D(event) {
        let viewer = new jsv2.SpectraViewer1D("#graph-1", {
        name: "test-viewer",  // Not used anywhere except by the user's own implementation (for identifying when there might be more than one viewer)
        width: 1650,
        height: 400,
        margin: {
            top: 50,
            bottom: 50,
            right: 50,
            left: 50
        },
        chartTitle: {
            text: "1D NMR Spectrum",
            // text: "EI-MS Spectrum",
            fontSize: 200,
            color: "black",
            underline: true
        },
        chartType: "1D-UV",
        dataset: [
            {   // Either provide dataArray OR fileUpload option [in both cases, eventually x and y should be set to Data.x and Data.y]
                dataArray: {
                    x: event.detail.x,
                    y: event.detail.y
                },
                isMirrorPlot: false,
                simplifyTolerance: 100,
                normalize: true,  // scale y to 1
                name: "Clomazone",
                // type: "simulated",  // experimental, simulated
                style: {
                    strokeColor: "red",
                    strokeWidth: 1
                },
            },
        ],
        axis: {
            minBoundaries: {
                x: [-1, 10], 
                y: [-1, 1]
            },
            x: {
                enabled: true,
                label: {
                    text: "Chemical Shift (ppm)",
                    fontSize: 15,
                },
                ticks: 20,
            },
            y: {
                enabled: true,
                label: {
                    text: "Intensity",
                    fontSize: 15,
                },
                ticks: 11,

            }
        },
        grid: {
            horizontal: {
                enabled: true,
                strokeColor: "steelblue",
                strokeWidth: 0.5,
                opacity: 0.1,
                ticks: 15
            },
            vertical: {
                enabled: true,
                strokeColor: "black",
                strokeWidth: 1,
                opacity: 1,
                ticks: 10
            }
        },
        zoomBox: {
            enabled: true,
            size: 15,
        },
        controls: {
            enabled: true,
            options: {
                zoom: {
                    vertical: true,
                    horizontal: true,
                    max: 100
                },
                pan: {
                    vertical: true,
                    horizontal: true
                },
                reset: true,
                download: {
                    formats: ["png", "svg", "pdf"],
                    filename: "spectrum"
                },
                // fullscreen: true
            }
        },
        zoomBox: {
            enabled: true,
            position: "top-right",
            width: 200,
            height: 100,
        },

    });

    viewer.draw();

}

function plotIr1D(event) {
    let viewer = new jsv2.SpectraViewer1D("#graph-1", {
        name: "test-viewer",  // Not used anywhere except by the user's own implementation (for identifying when there might be more than one viewer)
        width: 1650,
        height: 400,
        margin: {
            top: 50,
            bottom: 50,
            right: 50,
            left: 50
        },
        chartTitle: {
            text: "IR Spectrum",
            // text: "EI-MS Spectrum",
            fontSize: 200,
            color: "black",
            underline: true
        },
        // chartType: "1D-NMR",
        // chartType: "1D-LCMS",
        chartType: "1D-IR",
        dataset: [
            {   // Either provide dataArray OR fileUpload option [in both cases, eventually x and y should be set to Data.x and Data.y]
                // dataParser: dataParser,
                // dataArray: {
                //     x: event.detail.x,
                //     y: event.detail.y
                // },
                dataArray: {
                //     // x: [0, 2, 3, 4, 5, 6, 7, 8, 9, 11],
                //     // y: [0.0, 0.4, 2, 0.3, 0.0, 1.4, 0.3, 0.2, 0.1, 1]
                //     x: data.x,
                //     y: data.y
                    x: event.detail.x,
                    y: event.detail.y
                },
                isMirrorPlot: true,
                simplifyTolerance: 100,
                normalize: true,  // scale y to 1
                name: "Clomazone",
                // type: "simulated",  // experimental, simulated
                style: {
                    strokeColor: "red",
                    strokeWidth: 1
                },
            },
        
        //     {   
        //     // dataParser: dataParser,
        //     // dataArray: {
        //     //     x: event.detail.x,
        //     //     y: event.detail.y
        //     // },
        // {
        //     dataArray: {
        //         // x: [0, 2, 3, 4, 5, 6, 7, 8, 9, 11],
        //         // y: [0.0, 0.4, 2, 0.3, 0.0, 1.4, 0.3, 0.2, 0.1, 1]
        //         // x: data.x,
        //         // y: data.y,
        //         x: event.detail.x,
        //         y: event.detail.y,
        //     },
        //     isMirrorPlot: false,
        //     simplifyTolerance: 100,
        //     normalize: false,  // scale y to 1
        //     name: "Test Dummy Data",
        //     type: "experimental",  // experimental, simulated
        //     style: {
        //         strokeColor: "blue",
        //         strokeWidth: 1
        //     },
        //     id: "test-dummy-data-2"
        // },
        ],
        // dataset: {
        //     dataArray: {
        //         x: data.x,
        //         y: data.y,
        //         z: data.z
        //     }
        // },
        axis: {
            minBoundaries: {
                x: [-1, 10], 
                y: [-1, 1]
            },
            x: {
                enabled: true,
                label: {
                    text: "Chemical Shift (ppm)",
                    fontSize: 15,
                },
                ticks: 20,
            },
            y: {
                enabled: true,
                label: {
                    text: "Intensity",
                    fontSize: 15,
                },
                ticks: 11,

            }
        },
        grid: {
            horizontal: {
                enabled: true,
                strokeColor: "steelblue",
                strokeWidth: 0.5,
                opacity: 0.1,
                ticks: 15
            },
            vertical: {
                enabled: true,
                strokeColor: "black",
                strokeWidth: 1,
                opacity: 1,
                ticks: 10
            }
        },
        zoomBox: {
            enabled: true,
            size: 15,
        },
        controls: {
            enabled: true,
            options: {
                zoom: {
                    vertical: true,
                    horizontal: true,
                    max: 100
                },
                pan: {
                    vertical: true,
                    horizontal: true
                },
                reset: true,
                download: {
                    formats: ["png", "svg", "pdf"],
                    filename: "spectrum"
                },
                // fullscreen: true
            }
        },
        zoomBox: {
            enabled: true,
            position: "top-right",
            width: 200,
            height: 100,
        },

    });

    viewer.draw();
    console.log("Viewer drawn for IR 1D spectrum.");
}


function plotLcms1D(event) {
    let fileType = "lc_ms_1D"; // Assuming fileType is set to "lc_ms_1D" for LC-MS 1D spectrum
    let viewer = new jsv2.SpectraViewer1D(`#${GRAPH_ID}`, {
        name: "test-viewer",
        width: 1170,
        height: 400,
        margin: {
            top: 50,
            bottom: 50,
            right: 50,
            left: 50
        },

        chartTitle: {
            text: "1D NMR Spectrum",
            // text: "EI-MS Spectrum",
            fontSize: 200,
            color: "black",
            underline: true
        },
        // chartType: "1D-NMR",
        chartType: "1D-LCMS",
        dataset: [
            {   // Either provide dataArray OR fileUpload option [in both cases, eventually x and y should be set to Data.x and Data.y]
                // dataParser: dataParser,
                // dataArray: {
                //     x: event.detail.x,
                //     y: event.detail.y
                // },
                dataArray: {
                //     // x: [0, 2, 3, 4, 5, 6, 7, 8, 9, 11],
                //     // y: [0.0, 0.4, 2, 0.3, 0.0, 1.4, 0.3, 0.2, 0.1, 1]
                //     x: data.x,
                //     y: data.y
                    x: event.detail[0].x,
                    y: event.detail[0].y
                },
                isMirrorPlot: false,
                simplifyTolerance: 100,
                normalize: true,  // scale y to 1
                name: "Clomazone",
                // type: "simulated",  // experimental, simulated
                style: {
                    strokeColor: "red",
                    strokeWidth: 1
                },
            },
        ],
    });
    viewer.draw();
    console.log("Viewer drawn for LC-MS 1D spectrum.");
}



function plotNmrml2D(event) {
    let fileType = "nmrML_2D"; // Assuming fileType is set to "nmrML_2D" for NMRML 2D spectrum
    let viewer = new jsv2.SpectraViewer2D(`#${GRAPH_ID}`, {
        debug: false,
        width: 650,
        height: 650,
        zoom_min: 0.1,
        simplify_tolerance: 0.01,
        dataset: {  // MUST BE A JSON OBJECT NOT ARRAY AS 2D VIEWER EXPECTS A SINGLE DATASET with x,y,z
            dataArray: {
                x: event.detail.x,
                y: event.detail.y,
                z: event.detail.z
            }
        },
        highlight: {
            restriction_spectrum_id: 'Assignment',
            element_type: 'peak',
            display: { fill: 'rgba(238, 238, 255, 0.7)' },
            visible_only: false
        },
        assignmentTable: {
            container_id: '#assignments',
            edit_mode: false,
            clusterNavigationID: '#cluster-navigation-1',
        }


    });

    viewer.draw();
    console.log("Viewer drawn for NMRML 2D spectrum.");
}
    

function plotEims1D(event) {
    let fileType = "ei_ms_1D"; // Assuming fileType is set to "ei_ms_1D" for EI-MS 1D spectrum
    let viewer = new jsv2.SpectraViewer1D(`#${GRAPH_ID}`, {
        name: "test-viewer",
        width: 1170,
        height: 400,
        margin: {
            top: 50,
            bottom: 50,
            right: 50,
            left: 50
        },
        chartTitle: {
            text: "1D EI-MS Spectrum Viewer",
            fontSize: 20,
            color: "black",
            position: "top-right",
            css: {}
        },
        chartType: DATA_TYPES[fileType].name,
        dataset: [
            {   // Either provide dataArray OR fileUpload option [in both cases, eventually x and y should be set to Data.x and Data.y]
                dataArray: {
                    x: event.detail.x,
                    y: event.detail.y
                },
                isMirrorPlot: false,
                simplifyTolerance: 100,
                normalize: true,  // scale y to 1
                name: "Strychnine",
                // type: "simulated",  // experimental, simulated
                style: {
                    strokeColor: "red",
                    strokeWidth: 1
                },
                id: "simulated"
            },
        ],
        axis: {
            minBoundaries: {
                x: [-1, 10], 
                y: [-1, 1]
            },
            x: {
                enabled: true,
                label: {
                    text: "m/z",
                    fontSize: 15,
                },
                ticks: 20,
            },
            y: {
                enabled: true,
                label: {
                    text: "Intensity",
                    fontSize: 15,
                },
                ticks: 11,
                
            }
        },
        grid: {
            horizontal: {
                enabled: true,
                strokeColor: "steelblue",
                strokeWidth: 0.5,
                opacity: 0.1,
                ticks: 15
            },
            vertical: {
                enabled: true,
                strokeColor: "black",
                strokeWidth: 1,
                opacity: 1,
                ticks: 10
            }
        },
        controls: {
            enabled: true,
            options: {
                zoom: {
                    vertical: true,
                    horizontal: true,
                    max: 100
                },
                pan: {
                    vertical: true,
                    horizontal: true
                },
                reset: true,
                download: {
                    formats: ["png", "svg", "pdf"],
                    filename: "spectrum"
                },
                // fullscreen: true
            }
        }});
    viewer.draw();
    console.log("Viewer drawn for EI-MS 1D spectrum.");


}





function plotNmrml1D(event) {
    let fileType = "nmrML_1D"; // Assuming fileType is set to "nmrML_1D" for NMRML 1D spectrum
    let viewer = new jsv2.SpectraViewer1D(`#${GRAPH_ID}`, {
        name: "test-viewer",
        width: 1170,
        height: 400,
        margin: {
            top: 50,
            bottom: 50,
            right: 50,
            left: 50
        },
        chartTitle: {
            text: "1D NMR Spectrum Viewer",
            fontSize: 20,
            color: "black",
            position: "top-right",
            css: {}
        },
        chartType: DATA_TYPES[fileType].name,
        dataset: [
            {   // Either provide dataArray OR fileUpload option [in both cases, eventually x and y should be set to Data.x and Data.y]
                dataArray: {
                    x: event.detail.x,
                    y: event.detail.y
                },
                isMirrorPlot: false,
                simplifyTolerance: 100,
                normalize: true,  // scale y to 1
                name: "Strychnine",
                // type: "simulated",  // experimental, simulated
                style: {
                    strokeColor: "red",
                    strokeWidth: 1
                },
                id: "simulated"
            },
        ],
        axis: {
            minBoundaries: {
                x: [-1, 10], 
                y: [-1, 1]
            },
            x: {
            enabled: true,
            label: {
                text: "Chemical Shift (ppm)",
                fontSize: 15,
            },
            ticks: 20,
        },
        y: {
            enabled: true,
            label: {
                text: "Intensity",
                fontSize: 15,
            },
            ticks: 11,
            
        }
        },
        grid: {
            horizontal: {
                enabled: true,
                strokeColor: "steelblue",
                strokeWidth: 0.5,
                opacity: 0.1,
                ticks: 15
            },
            vertical: {
                enabled: true,
                strokeColor: "black",
                strokeWidth: 1,
                opacity: 1,
                ticks: 10
            }
        },
        controls: {
            enabled: true,
            options: {
                zoom: {
                    vertical: true,
                    horizontal: true,
                    max: 100
                },
                pan: {
                    vertical: true,
                    horizontal: true
                },
                reset: true,
                download: {
                    formats: ["png", "svg", "pdf"],
                    filename: "spectrum"
                },
                // fullscreen: true
            }
        },
        assignmentTable: {
            enabled: true,
            containerID: "#assignments",
            clusterNavigationID: "#cluster-navigation-1",
            // data: event.detail.assignmentData
            data: [event.detail.assignmentData],
            structure: {
                containerID: '#structure',
                use_jsmol: true,
                show_atom_numbers: true,
                show_hydrogen: true,
                width: 400,
                height: 400,
                format: 'nmrml',
            },
        },
    });

    viewer.draw();
    console.log("Viewer drawn for NMRML 1D spectrum.");


}